import { Component, OnInit, ViewChild } from '@angular/core';
import { _HttpClient, ModalHelper } from '@delon/theme';
import { STColumn, STComponent } from '@delon/abc';
import {SFComponent, SFSchema} from '@delon/form';
import {NzTableComponent, NzMessageService} from 'ng-zorro-antd';
import {UserDeptEditComponent} from "./edit/edit.component";
import {CacheService} from '@delon/cache';
import {DeptService} from "@ecip/service";

@Component({
  selector: 'app-user-dept',
  templateUrl: './dept.component.html',
  styleUrls: ['./dept.component.less']
})
export class UserDeptComponent implements OnInit {

  @ViewChild('sf') sf: SFComponent;
  searchSchema: SFSchema = {
    properties: {
      shortName: {
        type: 'string',
        title: 'åç§°'
      }
    }
  };
  @ViewChild('nzTable') nzTable: NzTableComponent;
  @ViewChild('st') st: STComponent;
  selectId;

  data = [];
  dataList = {}; //ææèç¹çmapï¼keyä¸ºidï¼valueä¸ºèç¹å¯¹è±¡

  constructor(private modal: ModalHelper, public msgSrv: NzMessageService,
              public deptService: DeptService) {
  }

  ngOnInit() {
    this.deptService.getList(this.sf.value).subscribe((res: any) => {
      this.data = res;
      this.data.forEach(item => {
        this.dataList[item.id] = item;
        // éå½å¤å®ï¼ç¶åå°+ åæ -
        // this.expansion(item);
      });
    });
  }

  // expansion(item: any) {
  //   // if (item.children !== null || item.children !== []) {
  //   let judge = JSON.stringify({"shortName": item.shortName}) ===JSON.stringify(this.sf.value);
  //   if (judge) {
  //     return;
  //   }
  //   if (item.children) {
  //     // console.log(JSON.stringify({"shortName": item.shortName}) ===JSON.stringify(this.sf.value));
  //     item.children.forEach(it => {
  //       item.expand = true;
  //       this.expansion(it);
  //     });
  //   }
  //   return;
  // }

  addChild(parentId) {
    this.selectId = parentId;
    this.add(false);
  }

  add(isRoot : boolean) {
    let parent;
    if (!isRoot) {
      if (!this.selectId) {
        this.msgSrv.warning("è¯·éæ©ç¶èç¹");
        return;
      }
      parent = this.dataList[this.selectId];
    }
    this.modal
      .createStatic(UserDeptEditComponent, {
        i: {} , isRoot: isRoot, parent: parent})
      .subscribe((res) => {
        this.dataList[res.id] = res;
        if (isRoot) {
          this.data.push(res);
          return;
        }
        if (!parent.children) {
          parent.children = [];
          parent.expand = true;
        }
        parent.children.push(res);
      });
  }

  edit(item) {
    this.modal
      .createStatic(UserDeptEditComponent, { record: item })
      .subscribe((res) => {
        item = Object.assign(item, res);
        this.dataList[res.id] = res;
      });
  }

  delete(item) {
    this.deptService.deleteById(item.id).subscribe(res => {
      this.msgSrv.success('å é¤æå');
      //æ ¹èç¹
      if (!item.pid) {
        this.data = this.data.filter(_item => _item.id !== item.id);
        this.dataList[item.id] = null;
        return;
      }
      //å­èç¹
      this.dataList[item.pid].children =
        this.dataList[item.pid].children.filter(_item => _item.id !== item.id);
    });
  }

  collapse(data: any, $event: boolean): void {
    if (!$event || data.children.length > 0) {
      return;
    }
    this.deptService.getChildren(data.id).subscribe(res => {
      data.children = res;
      data.children.forEach(item => {
        this.dataList[item.id] = item;
      });
    });
  }

}
